import {useQuery} from '@tanstack/react-query';

import {RQ_GET_PROFILE_API} from './constants';
import {rqCreateRequest} from './rqHttpUtils';

export const RQGetProfileAPI = (id, token, options = {}) => {
  return useQuery({
    queryKey: ['rq_get_admin_profile', {id, token}],
    queryFn: async ({queryKey, signal}) => {
      const {id, token} = queryKey[1];
      if (!token) {throw new Error('Invalid token: Token is required for API request');}

      const url = RQ_GET_PROFILE_API.url.replace('<%= id %>', id);

      console.log('Get profile data:', {url, token});

      // eslint-disable-next-line no-useless-catch
      try {
        const response = await rqCreateRequest(
          {...RQ_GET_PROFILE_API, url},
          null,
          token,
          null,
          signal,
        );

        return response;
      } catch (error) {
        throw error;
      }
    },
    ...options,
  });
};
